import styles from './Skeleton.module.css';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  variant?: 'text' | 'rect' | 'circle';
}

export function Skeleton({ width, height, className = '', variant = 'text' }: SkeletonProps) {
  const style = {
    width,
    height,
  };

  return <div className={`${styles.skeleton} ${styles[variant]} ${className}`} style={style} />;
}
